import InlineSVG from "react-inlinesvg";
import styled from "styled-components/macro";

const iconAssets = {
  command: "/assets/keyboard-shortcuts/command-key.svg",
  control: "/assets/keyboard-shortcuts/control-key-pc.svg",
  shift: "/assets/keyboard-shortcuts/shift-key.svg",
  option: "/assets/keyboard-shortcuts/option-key.svg",
  enter: "/assets/keyboard-shortcuts/enter-key.svg",
  escape: "/assets/keyboard-shortcuts/escape-key.svg",
};

function attrs(props) {
  const src = iconAssets[props.name];

  if (!src) {
    console.warn(`<KeyboardShortcutIcon> unknown asset key: ${props.name}`);
  }

  return { "aria-hidden": true, src };
}

export const KeybardShortcutIcon = styled(InlineSVG).attrs(attrs)`
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 5px;

  path {
    fill: #fff;
  }
`;
